import crypto from 'crypto-js';

export const key = 'd2ddaeb0b18b4c8ba6910bb05b6177d3';

export const getKR = () => {
  const r = +new Date();
  const k = crypto.SHA256(`${r}${key}`).toString();
  return { r, k };
};
